import React from 'react';
import { ScheduleType } from '../../utils/apollo/graphqlSchema';
import Scheduler from '../Scheduler';
import { useAppSelector } from '../../redux/hooks';
import {
  selectModalData,
  selectOpenedModalType,
} from '../../redux/selectors/modal';
import { ModalSliceType } from '../../redux/slices/modal';

export default () => {
  const isCohortImportToBrazeModalOpen = useAppSelector((state) =>
    selectOpenedModalType(state, ModalSliceType.CohortImportToBraze, ''),
  );
  const cohortImportData = useAppSelector(selectModalData);

  if (!(isCohortImportToBrazeModalOpen && cohortImportData)) {
    return null;
  }

  return (
    <Scheduler
      entityId={cohortImportData?.id}
      jobType={ScheduleType.BrazeCohortImport}
      prefilledName={cohortImportData?.name}
      isStaticDateRangeCohort={Boolean(
        cohortImportData?.start && cohortImportData?.end,
      )}
      ignoreModalData={true}
    />
  );
};
